let swRegistration = null;
let updateAvailable = false;

const SW_SCRIPT_VERSION = 'v4';

const UPDATE_POLL_MS = 60 * 1000;

const emitUpdate = (available) => {
  updateAvailable = available;
  try {
    window.dispatchEvent(
      new CustomEvent('connect-sw-update', {
        detail: { available: Boolean(available) },
      })
    );
  } catch {
    // ignore
  }
};

export const getUpdateAvailable = () => updateAvailable;

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js?v=${SW_SCRIPT_VERSION}`;
      const reg = await navigator.serviceWorker.register(swUrl);
      swRegistration = reg;

      try {
        setInterval(() => {
          checkForUpdate();
        }, UPDATE_POLL_MS);
      } catch {
        // ignore
      }

      try {
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            checkForUpdate();
          }
        });
      } catch {
        // ignore
      }

      if (reg.waiting) {
        emitUpdate(true);
      }

      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;

        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            emitUpdate(true);
          }
        });
      });

    } catch {
      // ignore
    }
  });
};

export const checkForUpdate = async () => {
  try {
    if (swRegistration) await swRegistration.update();
  } catch {
    // ignore
  }
};

export const applyUpdate = async () => {
  try {
    if (!swRegistration || !swRegistration.waiting) return;

    const waitingServiceWorker = swRegistration.waiting;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // The new service worker has taken control, navigate to the root to apply changes.
      window.location.href = '/';
    });

    waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
  } catch (err) {
    console.error('Failed to apply update:', err);
    // As a fallback, navigate to the root.
    window.location.href = '/';
  }
};

export const clearCacheAndReload = async () => {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // ignore
  }

  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch {
    // ignore
  }

  try {
    const url = new URL(window.location.href);
    url.searchParams.set('__reload', Date.now().toString());
    window.location.replace(url.toString());
  } catch {
    window.location.reload();
  }
};
